import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditInternationalScholarship = () => {
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    youtubeLink: "",
    officialLink: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const fetchScholarship = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/scholarships/singledata/${id}`
        );
        setFormData({
          title: response.data.title,
          description: response.data.description,
          youtubeLink: response.data.youtubeLink,
          officialLink: response.data.officialLink,
        });
      } catch (error) {
        console.error("Error fetching scholarship", error);
        alert("An error occured while loading the scholarship data");
      }
    };
    fetchScholarship();
  }, [API_BASE_URL, id]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.put(`${API_BASE_URL}/scholarships/${id}`, formData);
      alert("Scholarship updated successfully! ");
      navigate("/student-scholarship/all-international-scholarship");
    } catch (error) {
      console.error("Error updating scholarship", error);
      alert("An error occured while updating the scholarship");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div id="edit-central-gov-scholarship-main-container">
      <div className="edit-central-gov-heading-main-div">
        <h4>Edit International Scholarship</h4>
        <div className="header-main-btns">
          <button
            onClick={() =>
              navigate("/student-scholarship/international-scholarship")
            }
          >
            {" "}
            International Scholarship
          </button>
          <button
            onClick={() =>
              navigate("/student-scholarship/all-international-scholarship")
            }
          >
            All International Scholarship
          </button>
        </div>
      </div>
      <div className="edit-central-gov-scholarship-inner">
        <form onSubmit={handleSubmit}>
          <div className="edit-central-gov-input">
            <label>
              <b>Title</b>
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter Title"
              required
            />
          </div>
          <div className="edit-central-gov-input">
            <label>
              <b>Description</b>
            </label>
            <textarea
              name="description"
              style={{ height: "120px" }}
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Type description"
              required
            ></textarea>
          </div>
          <div className="edit-central-gov-input">
            <label>
              <b>YouTube Link</b>
            </label>
            <input
              type="text"
              name="youtubeLink"
              value={formData.youtubeLink}
              onChange={handleInputChange}
              placeholder="Enter YouTube Link"
            />
          </div>
          <div className="edit-central-gov-input">
            <label>
              <b>Other Link</b>
            </label>
            <input
              type="text"
              name="officialLink"
              value={formData.officialLink}
              onChange={handleInputChange}
              placeholder="Enter Other Link"
            />
          </div>
          <div className="new-chapter-form-buttons">
            <button
              type="submit"
              className="new-chapter-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              className="new-chapter-cancel-btn"
              onClick={() =>
                navigate("/student-scholarship/all-central-government")
              }
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditInternationalScholarship;
